import React from 'react';

const PageOverIntegraalProgrammeren: React.FC = () => (
  <>
    <header className="page-header container">
      <h1>Over integraal programmeren</h1>
      <p className="header-sub-title">
        Integraal programmeren is het proces waarin netbeheerders, provincies, gemeenten, waterschappen en andere betrokken (markt)partijen gezamenlijk maatschappelijk afgewogen keuzes maken 
        over de toekomstige inrichting van de infrastructuur in een regio. Integraal programmeren wordt ook wel integrale planafstemming genoemd.
      </p>
    </header>

    <section>
      <div className="container">
        <div className="row">
          <div className="col-12">
            {/* <Paper className="paper-content">content</Paper> */}
            <h4>Samenhangende opgaven in de fysieke leefomgeving</h4>
            <p>
              Alle partijen die ruimte innemen in de fysieke leefomgeving hebben hun eigen opgaven, vaak in dezelfde gebieden en in dezelfde periode. 
              Denk aan woningbouw, energietransitie, klimaatadaptatie, mobiliteit en de vervanging van verouderde infrastructuur. 
              Zonder goede afstemming kan dit leiden tot inefficiënt gebruik van capaciteit, hogere kosten en onnodige overlast voor bewoners en bedrijven.
            </p>
            <p>
              Door plannen integraal te programmeren ontstaat samenhang. 
              Werkzaamheden kunnen beter worden gecombineerd, in de juiste volgorde worden gerealiseerd en investeringen doelmatiger ingezet. 
              Dit levert voordelen op voor alle betrokken partijen én voor de omgeving.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h4>Waarom integraal programmeren steeds belangrijker wordt</h4>
            <p>
              De noodzaak voor integraal programmeren neemt toe. De druk op de openbare ruimte groeit, terwijl tijd, geld, capaciteit en beschikbare ruimte schaars zijn. 
              Tegelijkertijd bestaat de wens om de overlast voor de omgeving zoveel mogelijk te beperken.
            </p>
            <p>
              Alleen door vroegtijdige en structurele samenwerking tussen overheden, woningcorporaties, waterschappen, netbeheerders en marktpartijen is het mogelijk om deze opgaven binnen de beschikbare randvoorwaarden te realiseren. 
              Integraal programmeren ondersteunt het maken van strategische keuzes en het tijdig signaleren van knelpunten.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h4>Eén platform voor integrale planafstemming: infraplannen.nl</h4>
            <p>
              Netbeheerders hebben vaak te maken met meer dan honderd gemeenten, tientallen waterschappen en vele andere samenwerkingspartners. 
              Daarom hebben de netbeheerders van elektra, gas, water, media en stadswarmte gezamenlijk het initiatief genomen voor één sectorbreed platform.
            </p>
            <p>
              Stichting Mijn Aansluiting realiseerde infraplannen.nl: een platform dat is gericht op het efficiënter afstemmen van strategische infrastructuurplannen voor de middellange tot lange termijn (drie tot vijftien jaar vooruit). 
              Het platform faciliteert het delen en afstemmen van plannen en draagt bij aan het gesprek over prioriteiten en keuzes.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h4>Meer weten over succesvolle integrale afstemming?</h4>
            <p>
              Stichting Mijn Aansluiting werkt daarnaast mee aan <a href="https://www.desamenwerkwijzer.nl/" target="_blank" rel="noopener noreferrer">De Samenwerkwijzer</a>: een website met praktische informatie over efficiënte planafstemming. De Samenwerkwijzer bevat onder andere een stappenplan, tips, praktijkervaringen en formats ter ondersteuning van succesvol integraal programmeren.
            </p>
          </div>
        </div>
      </div>
    </section>
  </>
);

export default PageOverIntegraalProgrammeren;